import { Component, Input } from '@angular/core';
import { ICON } from '@core/util/icon';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import {
	StewartCancelModalData,
	StewartCancelModalComponent,
} from '../cancel-modal/cancel-modal.component';
import { BlankTitleInsurance } from '../../../chicago/chicago.component';
import {
	StewartModalComponent,
	StewartModalData,
} from '../../stewart-modal/stewart-modal.component';
import { SubmitFile } from '@models/title-insurance/stewart';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { StewartSelectors } from '@state/global/title-insurance/stewart';
import { openClose } from '@core/animations/animations';
import { TestHooks } from './flagged.hooks';

@Component({
	selector: 'app-stewart-flagged',
	templateUrl: './flagged.component.html',
	styleUrls: ['./flagged.component.scss'],
	animations: [openClose()],
	standalone: false,
})
export class StewartFlaggedComponent {
	testHooks = TestHooks;
	public blankTitleInsurance = BlankTitleInsurance;
	public ICON = ICON;
	public loading = false;
	@Input() matterId: string;
	@Input() status: number;
	@Input() thirdPartyId: number;
	@Input() loginUrl: string;

	@SelectSnapshot(StewartSelectors.previousPayload) previousPayload: SubmitFile;

	constructor(private matDialog: MatDialog) {}

	cancel(): void {
		const data: StewartCancelModalData = {
			status: this.status,
		};

		const modalRef = this.matDialog.open(StewartCancelModalComponent, {
			data,
			maxWidth: '450px',
			width: '90%',
		});

		modalRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((value) => {
				if (value) {
					this.matDialog.open(StewartModalComponent);
				}
			});
	}

	openPortal() {
		this.matDialog.open(StewartModalComponent);
	}

	submit(): void {
		const data: StewartModalData = {
			submitNewOrder: false,
		};

		this.matDialog.open(StewartModalComponent, { data });
	}
}
